export function initializeWhenNear(
  element: Element,
  initialize: () => void | (() => void),
  rootMargin = '75% 0px',
) {
  let cleanup: void | (() => void)
  let initialized = false
  let disposed = false

  const start = () => {
    if (disposed || initialized) return
    initialized = true
    cleanup = initialize()
  }

  if (!('IntersectionObserver' in window)) {
    start()
    return () => {
      disposed = true
      cleanup?.()
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return
      observer.disconnect()
      start()
    },
    { rootMargin, threshold: 0.01 },
  )

  observer.observe(element)

  return () => {
    disposed = true
    observer.disconnect()
    cleanup?.()
  }
}
